import * as React from 'react'
import { translate } from 'react-translate'

class MdDropdown extends React.Component<MdDropdownProps, MdDropdownState> {

  constructor(props: any) {
    super(props)
    this.state = {
      focused: false
    }
  }

  public clickOption(option, e) {
    e.preventDefault()
    option.logic()
  }

  public render() {
    let t = this.props.t
    return (
      <nav
          className={'download-selector-wrapper download-selector ' + (this.state.focused ? 'active' : '')}
          ng-keydown='navigate($event)'
          onMouseOver={
            () => {
              this.setState({
                focused: true
              })
            }
          }
          onMouseLeave={
            () => {
              this.setState({
                focused: false
              })
            }
          }>
          <div className='md-downloads-input'>
              <div className='export-text'>{t('Export')}</div>
              <div className='download-icon icon-download'></div>
          </div>
          {this.state.focused ? (
          <div className='md-download-list'>
            <ul>
                {this.props.options.map((option, id) => {
                  return (
                    <li key={id}>
                      <a onClick={(e) => this.clickOption(option, e)} title={option.title}>{t(option.title)}</a>
                    </li>
                  )
                })}
            </ul>
          </div>
          ) : null}
      </nav>
    )
  }
}

export default translate('MdDropdown')(MdDropdown)
export { MdDropdown as MdDropdownUnconnected }



// WEBPACK FOOTER //
// ./react/components/widgets/MdDropdown.tsx